import React, { FC } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { WorkspaceBreadcrumbs } from "../pages/Workspace/Header/WorkspaceBreadcrumbs/WorkspaceBreadcrumbs";
import { useSaveWorkspace } from "../pages/Workspace/Header/hooks/useSaveWorkspace";
import { SaveWorkspaceButton } from "../pages/Workspace/Header/SaveWorkspaceButton";
import Stack from "@mui/material/Stack";
import { useWorkspaceNavigationBlocker } from "../hooks/useWorkspaceNavigationBlocker";
import { UnsavedWorkspaceChangesDialog } from "./UnsavedWorkspaceChangesDialog";

interface WorkspaceHeaderProps {
  title: string;
  subheader?: React.ReactNode;
}

export const WorkspaceHeader: FC<WorkspaceHeaderProps> = ({
  title,
  subheader,
}) => {
  const {
    handleSave,
    handleSaveAsNew,
    isSaving,
    hasUnsavedChanges,
    userCanSave,
    discardChanges,
  } = useSaveWorkspace();

  const { onClose, onSave, onCancel, isBlocked } =
    useWorkspaceNavigationBlocker({
      handleSave,
      handleSaveAsNew,
      hasUnsavedChanges,
      userCanSave: !!userCanSave,
      isSaving,
      discardChanges,
    });

  return (
    <>
      <UnsavedWorkspaceChangesDialog
        disableActions={isSaving}
        userCanSave={!!userCanSave}
        open={isBlocked}
        onClose={onClose}
        onCancel={onCancel}
        onSave={onSave}
      />
      <Box
        display="flex"
        flexDirection="column"
        gap="15px"
        width="100%"
        minWidth={0}
        maxWidth="100%"
      >
        <Box width="100%" minWidth={0} maxWidth="100%">
          <WorkspaceBreadcrumbs />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            minWidth={0}
            maxWidth="100%"
          >
            <Typography
              // format ID such as workspace-header-market-landscape
              id={`workspace-header-${title.toLowerCase().replace(/\s+/g, "-")}`}
              fontSize="32px"
              fontWeight={300}
              color="#3a3a3a"
              lineHeight={1}
            >
              {title}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center">
              <SaveWorkspaceButton
                userCanSave={userCanSave ?? false}
                hasUnsavedChanges={hasUnsavedChanges}
                isSaving={isSaving}
                onSave={handleSave}
                onSaveAsNew={handleSaveAsNew}
              />
            </Stack>
          </Box>
        </Box>
        {subheader}
      </Box>
    </>
  );
};
